import { GroupEditMode } from "@/Administration/Models/UI/Group/GroupEditMode";
import { IGroupTabModel } from "@/Administration/Models/UI/Group/IGroupTabModel";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { GroupDetailsSettingEditComponent } from "./GroupDetailsSettingEditComponent";
import { GroupDetailsSettingViewComponent } from "./GroupDetailsSettingViewComponent";

interface IGroupDetailsPanelComponentProps {
    model: IGroupTabModel;
}

class GroupDetailsPanelComponentState {

}

class GroupDetailsPanelComponent extends React.Component<IGroupDetailsPanelComponentProps, GroupDetailsPanelComponentState> {
    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        return (
            <div className="fxheight admin-users-right-section">
                <div data-scrolling data-hvar={60} className="scrollable">
                    {(this.props.model.get("GroupEditMode") === GroupEditMode.Create || this.props.model.get("GroupEditMode") === GroupEditMode.Edit) && (
                        <GroupDetailsSettingEditComponent
                            model={this.props.model}
                        />
                    )}

                    {(this.props.model.get("GroupEditMode") === GroupEditMode.View && this.props.model.get("SelectedGroup") != null) && (
                        <GroupDetailsSettingViewComponent
                            model={this.props.model}
                        />
                    )}

                </div>
                <div className="meta-footer">
                    {(this.props.model.get("GroupEditMode") === GroupEditMode.Create || this.props.model.get("GroupEditMode") === GroupEditMode.Edit) &&
                        this.renderCreateModeButtons()
                    }

                    {(this.props.model.get("GroupEditMode") === GroupEditMode.View && this.props.model.get("SelectedGroup") != null) &&
                        this.renderViewModeButtons()
                    }
                </div>
            </div>
        );
    }

    private renderCreateModeButtons(): JSX.Element {
        return (
            <div>
                <ButtonControl
                    onClick={() => sessionStore.dispatch(LocalOperations.AdministrationGroup.SaveAndApplyGroup)}
                    label={cacheStore.GetString("SaveLabel")}
                    className="btn btn-primary pull-right"
                />
                <ButtonControl
                    label={cacheStore.GetString("CancelLabel")}
                    onClick={() => sessionStore.dispatch(LocalOperations.AdministrationGroup.CancelEditGroup)}
                    className="btn btn-default pull-right push-right-5"
                />
            </div>
        );
    }

    private renderViewModeButtons(): JSX.Element {
        return (
            <div>
                <ButtonControl
                    onClick={() => sessionStore.dispatch(LocalOperations.AdministrationGroup.ModifyGroup)}
                    label={cacheStore.GetString("ModifyLabel")}
                    className="btn btn-primary pull-right"
                />
            </div>
        );
    }
}

export { GroupDetailsPanelComponent };
